import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaBars } from "react-icons/fa";
import "./navbar.css";

const gurukulData = {
  "MAYALAWAS GURUKUL": {
    img: "/mayalawas.jpg",
    description: "A serene gurukul with top facilities.",
  },
  "BIJROL KHEDA GURUKUL": {
    img: "/kheda.jpg",
    description: "Empowering students with knowledge and wisdom.",
  },
  "SAYALA GURUKUL": {
    img: "/sayala.jpg",
    description: "A modern gurukul for holistic learning.",
  },
  "SAWAI CHOTI GURUKUL": {
    img: "/churu.jpg",
    description: "Excellence in education and culture.",
  },
  "RAITHAL GURUKUL": {
    img: "/raithal1.jpg",
    description: "Primary education with Vedic values in Jalore.",
  },
};

const facilitiesData = {
  HOSTEL: {
    img: "/Hostel.png",
    description: "Comfortable living for students with all amenities.",
  },
  TRANSPORTATION: {
    img: "/transportation.jpg",
    description: "Safe and reliable transport facilities.",
  },
};

const Navbar = () => {
  const [submenuOpen, setSubmenuOpen] = useState(null); // Track which submenu is open (either "campus" or "facilities")
  const [selectedCampus, setSelectedCampus] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);  // Added for Facility
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const navigate = useNavigate();
  

  const handleVisitClick = (type, name) => {
    if (type === "campus") {
      navigate(`/gurukul/${name.toLowerCase().replace(/\s+/g, "-")}`);
    } else if (type === "facility") {
      navigate(`/facility/${name.toLowerCase().replace(/\s+/g, "-")}`);
    }
    setIsMobileMenuOpen(false); // Close mobile menu after clicking a submenu item
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setSubmenuOpen(null); // Close submenu when toggling mobile menu
  };

  
  return (
    <nav className="navbar">
      <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
        <FaBars />
      </div>
      <ul className={`navbar-menu ${isMobileMenuOpen ? "active" : ""}`}>

      <li className="menu-item" onClick={() => { navigate("/"); setIsMobileMenuOpen(false); }}>HOME</li>
        {/* Gurukul Campus */}
        <li
          className="menu-item-prime-1"
          onMouseEnter={() => !isMobileMenuOpen && setSubmenuOpen("campus")}
          onMouseLeave={() => !isMobileMenuOpen && setSubmenuOpen(null)}
          onClick={() => setSubmenuOpen(submenuOpen === "campus" ? null : "campus")}
          // onClick={() => { navigate("/"); setIsMobileMenuOpen(false); }}
        >
          GURUKUL CAMPUS
          {submenuOpen === "campus" && (
            <div className="submenu-container">
              <ul className="submenu">
                {Object.keys(gurukulData).map((campus) => (
                  <li
                    key={campus}
                    onMouseEnter={() => !isMobileMenuOpen && setSelectedCampus(campus)}
                    onClick={() => handleVisitClick("campus", campus)}
                  >
                    {campus}
                  </li>
                ))}
              </ul>
              {selectedCampus && !isMobileMenuOpen && (
                <div className="campus-preview">
                  <img src={gurukulData[selectedCampus].img} alt={selectedCampus} />
                  <h3>{selectedCampus}</h3>
                  <p>{gurukulData[selectedCampus].description}</p>
                  <button onClick={() => handleVisitClick("campus", selectedCampus)}>
                    Visit This Branch
                  </button>
                </div>
              )}
            </div>
          )}
        </li>

        <li className="menu-item" onClick={() => { navigate("/admission"); setIsMobileMenuOpen(false); }}>ADMISSIONS</li>

        {/* Facilities */}
        <li
          className="menu-item-prime-2"
          onMouseEnter={() => !isMobileMenuOpen && setSubmenuOpen("facilities")}
          onMouseLeave={() => !isMobileMenuOpen && setSubmenuOpen(null)}
          onClick={() => setSubmenuOpen(submenuOpen === "facilities" ? null : "facilities")}
          // onClick={() => { navigate("/"); setIsMobileMenuOpen(false); }}
        >
          FACILITIES

          {submenuOpen === "facilities" && (
            <div className="submenu-container">
              <ul className="submenu">
                {Object.keys(facilitiesData).map((facility) => (
                  <li
                    key={facility}
                    onMouseEnter={() => !isMobileMenuOpen && setSelectedFacility(facilitiesData[facility])}
                    onClick={() => handleVisitClick("facility", facility)}
                  >
                    {facility}
                  </li>
                ))}
              </ul>
              {selectedFacility && !isMobileMenuOpen && (
                <div className="campus-preview">
                  <img src={selectedFacility.img} alt="Facility Preview" />
                  <h3>{selectedFacility.description}</h3>
                  <button onClick={() => handleVisitClick("facility", selectedFacility)}>
                    Learn More
                  </button>
                </div>
              )}
            </div>
          )}
        </li>

        {/* Other Navigation Links */}
        
        <li className="menu-item" onClick={() => { navigate("/about"); setIsMobileMenuOpen(false); }}>ABOUT US</li>
        {/* <DharmaSetuMenu /> */}
        {/* <li className="menu-item" onClick={() => { navigate("/vedic-store"); setIsMobileMenuOpen(false); }}>VEDIC STORE</li>
        <li className="menu-item" onClick={() => { navigate("/login"); setIsMobileMenuOpen(false); }}>LOGIN PORTAL</li> */}

        {/* Search Icon */}
        {/* <li className="menu-item">
          <FaSearch />
        </li> */}



        <div className="search-container">
            <li 
              className="menu-item search-icon" 
              onMouseEnter={() => setIsSearchOpen(true)} 
              onMouseLeave={() => setIsSearchOpen(false)}
            >
              <FaSearch />
              {isSearchOpen && (
                <input
                  type="text"
                  className="search-box"
                  placeholder="Search here..."
                />
              )}
            </li>
          </div>

        <li className="menu-nav-image">
          <div className="menu-nav-des">
            <img src="logoJ.jpeg" className="navv-img menu-nav-des" alt="Menu Icon" />
          </div>
        </li>
        
      </ul>
    </nav>
  );
};

export default Navbar;
